import script from "./GGanttLabelColumn.vue?vue&type=script&setup=true&lang=ts"
export * from "./GGanttLabelColumn.vue?vue&type=script&setup=true&lang=ts"

import "./GGanttLabelColumn.vue?vue&type=style&index=0&id=7bcd6723&lang=css"

const __exports__ = script;

export default __exports__